import { render, staticRenderFns } from "./c-content-chart-invest-bar.vue?vue&type=template&id=130c79c4&"
import script from "./c-content-chart-invest-bar.vue?vue&type=script&lang=js&"
export * from "./c-content-chart-invest-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports